import Vast from '../index';
import { isHttpUrl } from '../lib';
/*
* This method is responsible for rendering a nonlinear ad
*/
export function playNonLinearAd(creative) {
  creative.variations.map((variation) => {
    const clickThrough = () => {
      if (isHttpUrl(variation.nonlinearClickThroughURLTemplate)) {
        window.open(variation.nonlinearClickThroughURLTemplate, '_blank');
      }
      this.nonLinearVastTracker.click(null, this.macros);
    };
    const mount = (ressourceContainer) => {
      const slot = variation.adSlotID && document.getElementById(variation.adSlotID);
      (slot || this.player.el()).appendChild(ressourceContainer);
    };

    // An HTMLResource is not rendered: inserted as markup, the ad's scripts would run in this
    // page's origin.
    if (!variation.staticResource && !isHttpUrl(variation.iframeResource)) return variation;

    this.trackImpression(this.nonLinearVastTracker, this.macros);

    // image
    if (variation.staticResource) {
      const ressourceContainer = document.createElement('div');
      this.domElements.push(ressourceContainer);
      Vast.applyNonLinearCommonDomStyle(ressourceContainer);

      const ressource = document.createElement('img');
      ressource.addEventListener('click', clickThrough);
      ressourceContainer.style.maxWidth = variation.expandedWidth;
      ressourceContainer.style.maxHeight = variation.expandedHeight;
      ressource.src = variation.staticResource;

      // add close button
      const closeButton = Vast.getCloseButton(() => ressourceContainer.remove());
      closeButton.style.display = variation.minSuggestedDuration ? 'none' : 'block';

      if (variation.minSuggestedDuration) {
        setTimeout(() => {
          closeButton.style.display = 'block';
          ressourceContainer.appendChild(closeButton);
        }, variation.minSuggestedDuration * 1000);
      }
      ressourceContainer.appendChild(ressource);
      mount(ressourceContainer);
    }

    // iframe
    if (isHttpUrl(variation.iframeResource)) {
      const ressourceContainer = document.createElement('iframe');
      this.domElements.push(ressourceContainer);
      Vast.applyNonLinearCommonDomStyle(ressourceContainer);
      ressourceContainer.addEventListener('click', clickThrough);

      ressourceContainer.style.maxWidth = variation.expandedWidth;
      ressourceContainer.style.maxHeight = variation.expandedHeight;

      ressourceContainer.src = variation.iframeResource;
      mount(ressourceContainer);
      if (variation.minSuggestedDuration) {
        setTimeout(() => {
          ressourceContainer.remove();
        }, variation.minSuggestedDuration * 1000);
      }
    }
    return variation;
  });
}
